import { SxProps } from '@mui/material';
import { black, grey7, grey8, red2, red3 } from 'app/components/ThemeProvider/colors';
import { CSSProperties } from 'react';

export const styleForm: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '100%',
};
export const infoText: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '26px',
  mb: '12px',
  fontWeight: '600',
};

export const documentBox: SxProps = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: 'rgba(234, 234, 234, 0.40)',
  p: '16px 18px',
  borderRadius: '8px',
  mb: '16px',
  cursor: 'pointer',
};

export const docName: SxProps = {
  fontFamily: 'Yelo',
  color: black,
  fontSize: '17px',
};

export const docInfo: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '13px',
  color: grey8,
};

export const checkBoxLabel: SxProps = {
  color: black,

  '& .MuiTypography-root': {
    fontFamily: 'Yelo',
    fontSize: '15px',
  },
};

export const btnBox: SxProps = {
  display: 'flex',
  flexDirection: 'column',
};

export const modalBoxPaper: SxProps = {
  p: '50px 40px',
};

export const modalBoxContent: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  p: '0',
};

export const modalBoxText: SxProps = {
  fontFamily: 'Yelo',
  color: black,
  fontSize: '26px',
  fontWeight: '500',
};

export const modalBoxDesc: SxProps = {
  fontFamily: 'Yelo',
  color: grey8,
  fontSize: '17px',
  fontWeight: '400',
  mb: '22px',
};

export const warningBox: SxProps = {
  display: 'flex',
  alignItems: 'center',
  p: '14px 16px',
  border: `1px solid ${red2}`,
  borderRadius: '10px',
  background: red3,
  mt: '28px',

  '@media screen and (max-height: 864px)': {
    mt: '24px',
  },
};

export const errorText: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '14px',
  color: black,
};

export const btn: SxProps = {
  width: '100%',
  fontSize: '16px',
  mt: '80px',
};

export const inputInfo: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '14px',
  mb: '8px',
  color: grey7,

  '@media screen and (max-height: 864px)': {
    mb: '6px',
  },
};
